import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from '@nuxtjs/composition-api'
import { useTipsModel } from './../model'
import { ButtonClose } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'TipsCustom',
  props: {
  sumOrders: {
    type: [Number, String],
    required: true,
    default: 0
  },
  value: {
    type: [Number, String],
    required: true,
    default: 0
  },
  role: {
    type: String,
    required: true,
    default: ''
  },
  currencyIcon: {
    type: String,
    required: false,
    default: ''
  }
},
  setup(__props) {

const props = __props

const tipsModel = useTipsModel()



const componentRerender = ref<boolean>(false)

const forceRerender = () => {
  setTimeout(() => {
    componentRerender.value = true
  }, 1)
}

const resetTips = () => {
  tipsModel.changeTips({
    role: props.role,
    sum: 0,
    selectedPercent: 0,
    manualTips: false,
    hideActiveStylePercent: false
  })
}

const customTips = (value: Event) => {
  const target = value.target as HTMLInputElement
  const regexp = /[^\d]+/
  const res = regexp.test(target.value)
  if (!res) {
    if (target.value.length && parseInt(target.value) > 0) {
      tipsModel.changeTips({
        role: props.role,
        sum: parseInt(target.value),
        selectedPercent: 0,
        manualTips: true,
        hideActiveStylePercent: false
      })
      return
    }

    if (target.value.length < 1 || parseInt(target.value) < 1) {
      tipsModel.changeTips({
        role: props.role,
        sum: 0,
        selectedPercent: 0,
        manualTips: false,
        hideActiveStylePercent: false
      })
    }
  }
}

onMounted(() => {
  forceRerender()
})

return { __sfc: true,tipsModel, props, componentRerender, forceRerender, resetTips, customTips, ButtonClose }
}

})